import { Ranking } from '../components/home/ranking';
import { Trophy } from 'lucide-react';
import { Spinner } from '../components/spinner';
import { useLeaderboardSession } from '../query';
import styles from './rewards.module.css';

export const Rewards = () => {
  const {
    isError,
    isLoading,
    data: users,
  } = useLeaderboardSession();

  if (isError) return null;
  if (!isLoading && !users.length) return null;

  return (
    <>
      <header className={ styles.rewards }>
        <Trophy />
        <h1>
          <small>
            Monthly
          </small>
          <span>
            Rewards
          </span>
        </h1>
      </header>
      
      <p>
        At the end of each month, the top winner will receive a special <strong>locked</strong> squishy.
      </p>

      <ol>
        { isLoading && <Spinner /> }
        { users.map((user, idx) => (
          <Ranking
            as="li"
            variant="small"
            key={ idx }
            user={ user }
            idx={ idx }
            score={ user.sessionScore }
            catches={ user.sessionCatches }
          />
        )) }
      </ol>
    </>
  );
};